import type { ActionResponse } from 'api/__GENERATED';
import { timeUtility } from 'utility';

// Maps a single ActionResponse DTO to Data.Action.
// startAt/endAt are ISO strings from the API — toTimeDate converts them to
// the DateItem structure expected by the domain type.
function toAction(dto: ActionResponse): Data.Action {
  const {
    id,
    improvementAreaId,
    title,
    problemStatement,
    solutionProposal,
    definitionOfDone,
    status,
    priority,
    startAt: _startAt,
    endAt: _endAt,
    responsibleEmployee,
    suggestionIds,
  } = dto;

  const action: Data.Action = {
    id,
    improvementAreaId,
    name: title ?? '',
    problemStatement,
    solutionProposal,
    definitionOfDone,
    status,
    priority,
    startAt: timeUtility.toTimeDate(new Date(_startAt)),
    endAt: timeUtility.toTimeDate(new Date(_endAt)),
    responsibleEmployee,
    suggestionIds,
  };

  return action;
}

export { toAction };
